import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

const GlobalMenuIcon = ({ route, text, children, className }) => (
  <Link to={route} className={`link-icon ${className}`}>
    {children}
    <label className="icon-label">{text}</label>
  </Link>
);

GlobalMenuIcon.propTypes = {
  route: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default GlobalMenuIcon;
